//
//
//
//
//
//
//

import ReportManagementPage from '@/apps/data-platform/modules/report_management/reportManagementPage/ReportManagementPage.vue';
export default {
  components: {
    ReportManagementPage: ReportManagementPage
  },
  data: function data() {
    return {
      show_report: false,
      is_admin: false
    };
  },
  created: function created() {
    this.is_admin = window.userInfo.userRoles.includes('audience_admin');
    this.show_report = true;
  }
};